export const API_URL = "https://api2.algazali.ac.id";
